module.exports = __webpack_public_path__ + "8d30b01ee6cec572fdd7cbf2f321fa50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/stryker_2023_chart.png
// module id = 1736
// module chunks = 0